export const MEDIA_API_ROUTES = {
  GET_UPLOAD_URL: "/admin/media/upload-url",
  GET_SIGNED_URL: "/admin/media/signed-url",
};
